"use client";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/app/context/LangContext";
import { SupportedLanguages } from "@/types/dictionary";
import { useRouterManager } from "@/lib/router-manager";
import { BookingSubject } from "@/types/calendar";


interface ScheduleDemoBtnProps {
  ctaText?: any;
  subject?: BookingSubject;
  borderColor?: string; 
  textColor?: string;
  bgColor?: string;
}

export function ScheduleDemoBtn({ ctaText, borderColor, textColor, bgColor, subject }: ScheduleDemoBtnProps) {
  const lang = useLang();
  const routerManager = useRouterManager();
  return (
    <Button 
      className={`gap-3 font-rubik sm:text-[1rem] text-[0.8rem] sm:h-[3.3rem] h-[2.5rem] sm:w-[13rem] w-[12rem] rounded-[0.8rem] border-2 
      ${borderColor ? `border-${borderColor}` : "border-transparent"} 
      ${textColor ? `text-${textColor}` : "text-slate1"} 
      ${bgColor ? `bg-${bgColor}` : "bg-gray1"}
      transition-colors duration-300 hover:bg-black hover:text-white`}
      onClick={() => {
        routerManager.goToBookingPage(subject || BookingSubject.CONSULTATION);
      }}
    >
      {lang === SupportedLanguages.HE ? (
        <>
          <span className="font-[400]">{ctaText}</span>
          <ArrowLeft className="sm:h-[1.2rem] sm:w-[1.2rem] h-[1rem] w-[1rem] font-bold" />
        </>
      ) : (
        <>
          <span className="font-[400]">{ctaText}</span>
          <ArrowRight className="sm:h-[1.2rem] sm:w-[1.2rem] h-[1rem] w-[1rem] font-bold" />
        </>
      )}
    </Button>
  );
}
